<template>
  <div class="accordion">
    <div
      class="accordion__header"
      :class="{ active: isExpanded }"
      :style="headerStyleObj"
      @click="toggleExpansion"
    >
      <div class="title">
        <span>
          {{ title }}
        </span>
      </div>
      <div class="icon-wrapper">
        <fa
          icon="chevron-down"
          class="icon"
          :class="{ 'fa-rotate-180': isExpanded }"
        ></fa>
      </div>
    </div>
    <div
      ref="accordionBody"
      class="accordion__body"
      :style="{
        'background-color': bodyBackgroundColor
      }"
    >
      <slot name="body">Accordion body</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      default: 'Accordion Title'
    },
    headerBackgroundColor: {
      type: String,
      default: '#fff'
    },
    headerHoverBackgroundColor: {
      type: String,
      default: '#eee'
    },
    bodyBackgroundColor: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    headerStyleObj() {
      return {
        '--header-background-color': this.headerBackgroundColor,
        '--header-hover-background-color': this.headerHoverBackgroundColor
      };
    }
  },
  methods: {
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        this.$refs.accordionBody.style.maxHeight =
          this.$refs.accordionBody.scrollHeight + 'px';
      } else {
        this.$refs.accordionBody.style.maxHeight = 0;
      }
    }
  }
};
</script>

<style lang="scss">
.accordion {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    height: 3rem;
    color: #000;
    background-color: var(--header-background-color);
    cursor: pointer;
    transition: 0.4s;

    &.active,
    &:hover {
      background-color: var(--header-hover-background-color);
    }

    .title {
      font-weight: 600;
    }

    .icon-wrapper {
      .icon {
        transition: 0.4s;
      }
    }
  }

  &__body {
    padding: 0 1rem;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }
}
</style>
